import { styled, Chip } from '@mui/material'

export const ChipStyled = styled(Chip)(props => `
  ${props?.size === 'small' && `
    font-size: 11px;
    height: auto;
  `};
  ${(localStorage.getItem('button-style') === 'gradient' && props?.variant === ('contained' || 'undefined') && props?.color === 'primary') && `background: ${props?.theme?.palette?.primary?.gradient};`}
`)
